<template>
  <div>
    <v-toolbar
      tabs
      :style="{
        zIndex: 1,
        borderTop: '1px solid',
        borderBottom: '1px solid',
        borderColor: '#ccc',
      }"
      height="128"
      card
      color="#fff"
    >
      <v-layout row wrap align-center>
        <v-flex xs12>
          <v-breadcrumbs :items="breadcrumbs">
            <template v-slot:item="props">
              <router-link
                :to="props.item.href"
                :is="props.item.disabled ? 'span' : 'router-link'"
              >
                {{ props.item.text }}
              </router-link>
            </template>
            <template v-slot:divider>
              <v-icon>chevron_right</v-icon>
            </template>
          </v-breadcrumbs>
        </v-flex>
        <v-flex xs12>
          <div
            class="mr-3"
            :style="{
              padding: '8px',
              display: 'inline-block',
              backgroundColor: '#ef565c',
              borderRadius: '0.5rem',
            }"
          >
            <v-icon medium color="#fff">visibility</v-icon>
          </div>
          <h1 style="display: inline">Detalle horario</h1>
        </v-flex>
      </v-layout>
    </v-toolbar>
    <div class="schedule-container">
      <v-container fluid grid-list-xl>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card flat class="border-container" style="min-height: 400px">
              <v-card-text v-if="unauthorized">
                <div>
                    <h3 class="text-xs-center red--text text--darken-4">No tienes permisos para acceder a esta sección</h3>
                </div>
              </v-card-text>
              <v-card-text v-else>
                <div v-if="type == 'FULL_TIME'" class="pt-5">
                  <FullTimeForm
                    @onSubmit="onSubmit"
                    :initial-values="initialValues"
                    :selected="selectedForm"
                    read-only
                  />
                </div>
                <div v-if="type == 'HOURS_BY_DAY'">
                  <HoursByDayForm
                    @onSubmit="onSubmit"
                    :initial-values="initialValues"
                    :selected="selectedForm"
                    read-only
                  />
                </div>
              </v-card-text>
              <div style="position: absolute; top: 0px; right: 0px">
                <v-btn icon to="../">
                  <v-icon>close</v-icon>
                </v-btn>
              </div>
            </v-card>
          </v-flex>
        </v-layout>
		    <error v-model="toast.failed" text="Ups ocurrió un error"></error>
      </v-container>
    </div>
  </div>
</template>

<script>
import FullTimeForm from "./FullTime.vue";
import HoursByDayForm from "./HoursByDay.vue";
import moment from "moment";
import { mapGetters } from "vuex";
import error from "../../Dialogs/Error.vue";

const transform2Digits = (num) =>
            num.toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            });

export default {
  components: {
    FullTimeForm,
    HoursByDayForm,
    error,
  },
  data: () => ({
    feedback: {
      success: false,
      failed: false,
      working: false,
    },
    requestConfirmation: false,
    confirmed: false,
    formValues: null,
    type: "",
    initialValues: null,
    breadcrumbs: [
      {
        text: "Horarios",
        disabled: false,
        href: "/es/panel/checker",
      },
      {
        text: "Detalle horario",
        disabled: true,
        href: "/es/panel/checker/detail",
      },
    ],
    selectedForm: [],
    toast: {
      failed: false,
    },
    unauthorized: false,
  }),
  methods: {
    onSubmit() {},
    retrieveSchedule(id) {
      this.$store
        .dispatch("checker/retrieveSchedule", id)
        .then(({ data }) => {
          if(data.code === 1017) {
            console.log(data)
            this.unauthorized = true;
            return;
          }
          if (data.type == "FULL_TIME") {
            this.initialValues = {
              collaboratorIds: data.collaborators,
              type: "FULL_TIME",
              name: data.name,
              startTime: moment(data.startTime, "HH:mm:ss").format("hh:mm a"),
              endTime: moment(data.endTime, "HH:mm:ss").format("hh:mm a"),
              minutesEarly:
                transform2Digits(Math.floor(data.minutesEarly / 60)) +
                ":" +
                transform2Digits(data.minutesEarly % 60),
              minutesLate:
                transform2Digits(Math.floor(data.minutesLate / 60)) +
                ":" +
                transform2Digits(data.minutesLate % 60),
            };
          }
          if (data.type == "HOURS_BY_DAY") {
            const restDays = ((this.getBranch && this.getBranch.ableDays) || [])
              .filter((d) => {
                return !data.scheduleDays.some((s) => s.dayOfWeek == d.id);
              })
              .map((i) => ({
                dayOfWeek: i.id,
                startTime: "",
                endTime: "",
                enabled: true,
              }));

            this.initialValues = {
              collaboratorIds: data.collaborators,
              type: "HOURS_BY_DAY",
              name: data.name,
              minutesEarly:
                transform2Digits(Math.floor(data.minutesEarly / 60)) +
                ":" +
                transform2Digits(data.minutesEarly % 60),
              minutesLate:
                transform2Digits(Math.floor(data.minutesLate / 60)) +
                ":" +
                transform2Digits(data.minutesLate % 60),
              scheduleDays: [
                // los dias que tiene guardado el horario
                ...data.scheduleDays.map((i) => ({
                  ...i,
                  startTime: moment(i.startTime, "HH:mm:ss").format("hh:mm a"),
                  endTime: moment(i.endTime, "HH:mm:ss").format("hh:mm a"),
                  enabled: true,
                })),
                // los dias que tiene habilitado el colegio con lalores vacios
                ...restDays,
              ].sort((a, b) => {
                return a.dayOfWeek - b.dayOfWeek;
              }),
            };
          }
          this.type = data.type;
          this.selectedForm = [...data.collaborators];
        })
        .catch(e => {
          console.log(e)
          this.toast.failed= true;
        });
    },
  },
  mounted() {
    this.retrieveSchedule(this.$router.history.current.params.id);
  },
  computed: {
    ...mapGetters(["getBranch"]),
  },
};
</script>

<style scoped>
.schedule-container {
  background-color: #f5f5f5;
  overflow-y: scroll;
  height: calc(100vh - 192px);
}
.border-container {
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
}

/deep/ input[type=text]:disabled,
/deep/ input.display-time.all-selected.disabled {
    color: #7b8d8f;
}
</style>